import { Check, ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/shared/components/ui/dropdown-menu";
import type { RetroIntento } from "@/hooks/intentos/useRetrosActividad";

const formatoFecha = new Intl.DateTimeFormat("es-MX", {
  day: "numeric",
  month: "short",
  year: "numeric",
});

type Props = {
  intentos: RetroIntento[];
  /** Id del intento que se está viendo; null = el más reciente. */
  seleccionado: number | null;
  onSeleccionar: (id: number | null) => void;
  disabled?: boolean;
};

/** Selector para leer la retroalimentación de intentos anteriores. */
export function IntentoSelector({ intentos, seleccionado, onSeleccionar, disabled }: Props) {
  if (intentos.length < 2) return null;
  const ultimo = intentos[intentos.length - 1];
  const actual = intentos.find((i) => i.id === seleccionado) ?? ultimo;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        disabled={disabled}
        className="inline-flex h-8 items-center gap-1.5 rounded-full border border-[var(--border)] bg-[var(--card-background)] px-3 text-xs font-medium text-[var(--foreground)] transition hover:border-[var(--primary)] disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline-2 focus-visible:outline-[var(--primary)]"
      >
        Viendo: Intento {actual.numero}
        <ChevronDown size={14} className="opacity-60" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel className="text-xs opacity-60">Tus intentos</DropdownMenuLabel>
        {[...intentos].reverse().map((intento) => {
          const esUltimo = intento.id === ultimo.id;
          const activo = intento.id === actual.id;
          return (
            <DropdownMenuItem
              key={intento.id}
              onClick={() => onSeleccionar(esUltimo ? null : intento.id)}
              className="flex items-start gap-2 py-2"
            >
              <Check size={14} className={`mt-0.5 flex-shrink-0 ${activo ? "" : "invisible"}`} />
              <span className="flex min-w-0 flex-col">
                <span>
                  Intento {intento.numero}
                  {esUltimo && <span className="opacity-60"> · el más reciente</span>}
                </span>
                <span className="truncate text-xs opacity-60">
                  {formatoFecha.format(new Date(intento.creadoEl))}
                  {intento.archivoNombre ? ` · ${intento.archivoNombre}` : ""}
                </span>
              </span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
